<template>
  <v-table-wrapper
    :infinite-id="infiniteId"
    :list="list"
    :infinite-loading="infiniteLoading"
    :table-height="tableHeight"
    :with-select="isRoleAdmin"
    class="owners-table"
    v-on="$listeners"
  >
    <template #customColumns>
      <el-table-column
        prop="created_at"
        label="Добавлен"
        sortable="custom"
        class-name="owners-table__cell--date"
        min-width="124"
      >
        <template #default="{row:{dateJoined}}">
          {{ formatDate(dateJoined) }}
        </template>
      </el-table-column>
      <el-table-column prop="updated_at" label="Обновлён" class-name="owners-table__cell--date" min-width="100">
        <template #default="{row:{updatedAt}}">
          {{ formatDate(updatedAt) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="is_documents_uploaded"
        sortable="custom"
        label="Соглашение"
        class-name="owners-table__cell--status"
        min-width="138"
      >
        <template #default="{row:{agreementDocumentCount}}">
          <v-tag-group :value="!!agreementDocumentCount" :group="$options.DOCUMENTS_STATUSES_GROUP">
            <template #default="{ color, text }">
              <v-tag :color="color"> {{ text }}</v-tag>
            </template>
          </v-tag-group>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        sortable="custom"
        label="Имя собственника"
        class-name="owners-table__cell--name"
        min-width="244"
        show-overflow-tooltip
      >
        <template #default="{row:{name, id}}">
          <v-button
            v-if="name && id"
            class="owners-table__client-link"
            is-text
            :to="{ name: 'owner-edit', params: { ownerId: id } }"
            >{{ name }}</v-button
          >
          <template v-else>{{ name || '-' }} </template>
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="Телефон" class-name="owners-table__cell--phone" min-width="143">
        <template #default="{row:{ownerProfile, phone}}">
          <!--          todo: временно убрано [phone, ...ownerProfile.phones]-->
          <v-phones-popover :phones="[phone]"></v-phones-popover>
        </template>
      </el-table-column>
      <el-table-column
        v-if="isRoleAdmin"
        prop="agent"
        sortable="custom"
        class-name="owners-table__cell--agent"
        label="Агент"
        min-width="200"
        show-overflow-tooltip
      >
        <template #default="{row:{agent}}">
          <v-agent v-if="agent" :photo="agent.photo" @click.stop>
            {{ agent.name }}
          </v-agent>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="adverts" label="Объект" class-name="owners-table__cell--advert" min-width="110">
        <template #default="{row:{adverts}}">
          <v-adverts-popover :adverts="adverts"></v-adverts-popover>
        </template>
      </el-table-column>
      <el-table-column
        prop="advert_categories"
        label="Категория"
        class-name="owners-table__cell--adverts-category"
        width="210"
      >
        <template #default="{row:{ownerProfile}}">
          {{
            (ownerProfile && ownerProfile.advertCategories && formatAdvertCategories(ownerProfile.advertCategories)) ||
              '-'
          }}
        </template>
      </el-table-column>
      <el-table-column
        v-if="isRoleAdmin"
        prop="call_source"
        label="Источник"
        class-name="owners-table__cell--call-source"
        min-width="190"
      >
        <template #default="{row:{callSource}}">
          <div>{{ callSource.name || '-' }}</div>
        </template>
      </el-table-column>
    </template>
  </v-table-wrapper>
</template>

<script>
import VTableWrapper from '@/components/common/VTableWrapper.vue'
import VAgent from '@/components/common/VAgent.vue'
import { formatDate } from '@/utils/formatters'
import { mapGetters } from 'vuex'
import { MODULE_SESSION } from '@/store/modules/session/session.types'
import { DOCUMENTS_STATUSES_GROUP } from '@/constants/documentsStatuses'
import VTag from '@/components/common/VTag.vue'
import VTagGroup from '@/components/common/VTagGroup.vue'
import VPhonesPopover from '@/components/common/VPhonesPopover.vue'
import VAdvertsPopover from '@/components/common/VAdvertsPopover.vue'
import VButton from '@/components/common/VButton.vue'

export default {
  DOCUMENTS_STATUSES_GROUP,

  name: 'OwnersTable',
  components: {
    VButton,
    VAdvertsPopover,
    VPhonesPopover,
    VTableWrapper,
    VTagGroup,
    VTag,
    VAgent
  },
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    tableHeight: {
      type: Number,
      default: 500
    },
    infiniteId: {
      type: Number,
      required: true
    },
    infiniteLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      isRoleAdmin: `${MODULE_SESSION}/isRoleAdmin`
    })
  },
  methods: {
    formatAdvertCategories(categories) {
      return categories.length ? categories.map(category => category.name).join(', ') : '-'
    },
    formatDate(date) {
      return formatDate(date, '.')
    }
  }
}
</script>

<style lang="scss">
.owners-table {
  &__client-link {
    color: inherit !important;

    &:hover,
    &:focus {
      color: inherit;
      text-decoration: underline;
    }
  }
}
</style>
